import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Button, Card, Row, Col, Table } from 'react-bootstrap';
import { FaPlus, FaTrash } from 'react-icons/fa';

function NewInvoice() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    from: {
      name: 'Construction Co Ltd',
      address: '789 Builder Street',
      city: 'Construction City, ST 12345',
      phone: '(555) 123-4567',
      email: 'billing@constructionco.com'
    },
    client: '',
    jobSite: '',
    jobCode: '',
    date: new Date().toISOString().split('T')[0],
    lineItems: [
      {
        id: '1',
        description: '',
        jobCode: '',
        hours: '',
        rate: '',
        amount: '0.00'
      }
    ]
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFromChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      from: {
        ...prev.from,
        [name]: value
      }
    }));
  };

  const addLineItem = () => {
    setFormData((prev) => ({
      ...prev,
      lineItems: [
        ...prev.lineItems,
        {
          id: String(prev.lineItems.length + 1),
          description: '',
          jobCode: '',
          hours: '',
          rate: '',
          amount: '0.00'
        }
      ]
    }));
  };

  const removeLineItem = (id) => {
    setFormData((prev) => ({
      ...prev,
      lineItems: prev.lineItems.filter((item) => item.id !== id)
    }));
  };

  const updateLineItem = (id, field, value) => {
    setFormData((prev) => ({
      ...prev,
      lineItems: prev.lineItems.map((item) => {
        if (item.id === id) {
          const updatedItem = { ...item, [field]: value };
          if (field === 'hours' || field === 'rate') {
            const hours = field === 'hours' ? value : item.hours;
            const rate = field === 'rate' ? value : item.rate;
            updatedItem.amount = (parseFloat(hours || 0) * parseFloat(rate || 0)).toFixed(2);
          }
          return updatedItem;
        }
        return item;
      })
    }));
  };

  const calculateTotal = () => {
    return formData.lineItems
      .reduce((sum, item) => sum + parseFloat(item.amount || 0), 0)
      .toFixed(2);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // TODO: Implement invoice submission
    console.log('Form submitted:', formData);
    navigate('/invoices');
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1 className="h3 mb-0">Create New Invoice</h1>
      </div>

      <Form onSubmit={handleSubmit}>
        <Card className="mb-4">
          <Card.Body>
            <h2 className="h5 mb-3">Company Information</h2>
            <Row className="g-3">
              <Col md={6}>
                <Form.Group controlId="fromName">
                  <Form.Label>Company Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    value={formData.from.name}
                    onChange={handleFromChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="fromEmail">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={formData.from.email}
                    onChange={handleFromChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={12}>
                <Form.Group controlId="fromAddress">
                  <Form.Label>Address</Form.Label>
                  <Form.Control
                    type="text"
                    name="address"
                    value={formData.from.address}
                    onChange={handleFromChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="fromCity">
                  <Form.Label>City, State, ZIP</Form.Label>
                  <Form.Control
                    type="text"
                    name="city"
                    value={formData.from.city}
                    onChange={handleFromChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="fromPhone">
                  <Form.Label>Phone</Form.Label>
                  <Form.Control
                    type="tel"
                    name="phone"
                    value={formData.from.phone}
                    onChange={handleFromChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        <Card className="mb-4">
          <Card.Body>
            <h2 className="h5 mb-3">Client Information</h2>
            <Row className="g-3">
              <Col md={6}>
                <Form.Group controlId="client">
                  <Form.Label>Client Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="client"
                    value={formData.client}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="date">
                  <Form.Label>Date</Form.Label>
                  <Form.Control
                    type="date"
                    name="date"
                    value={formData.date}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="jobSite">
                  <Form.Label>Job Site</Form.Label>
                  <Form.Control
                    type="text"
                    name="jobSite"
                    value={formData.jobSite}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="jobCode">
                  <Form.Label>Project Code</Form.Label>
                  <Form.Control
                    type="text"
                    name="jobCode"
                    value={formData.jobCode}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        <Card className="mb-4">
          <Card.Body>
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h2 className="h5 mb-0">Line Items</h2>
              <Button
                variant="outline-primary"
                onClick={addLineItem}
                className="d-flex align-items-center"
              >
                <FaPlus className="me-2" /> Add Line Item
              </Button>
            </div>

            <div className="table-responsive">
              <Table>
                <thead>
                  <tr>
                    <th style={{ width: '35%' }}>Description</th>
                    <th>Job Code</th>
                    <th>Hours</th>
                    <th>Rate</th>
                    <th>Amount</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {formData.lineItems.map((item) => (
                    <tr key={item.id}>
                      <td>
                        <Form.Control
                          type="text"
                          value={item.description}
                          onChange={(e) =>
                            updateLineItem(item.id, 'description', e.target.value)
                          }
                          required
                        />
                      </td>
                      <td>
                        <Form.Control
                          type="text"
                          value={item.jobCode}
                          onChange={(e) =>
                            updateLineItem(item.id, 'jobCode', e.target.value)
                          }
                          required
                        />
                      </td>
                      <td>
                        <Form.Control
                          type="number"
                          value={item.hours}
                          onChange={(e) =>
                            updateLineItem(item.id, 'hours', e.target.value)
                          }
                          step="0.5"
                          min="0"
                          required
                        />
                      </td>
                      <td>
                        <Form.Control
                          type="number"
                          value={item.rate}
                          onChange={(e) =>
                            updateLineItem(item.id, 'rate', e.target.value)
                          }
                          step="0.01"
                          min="0"
                          required
                        />
                      </td>
                      <td>${item.amount}</td>
                      <td>
                        {formData.lineItems.length > 1 && (
                          <Button
                            variant="link"
                            className="text-danger p-0"
                            onClick={() => removeLineItem(item.id)}
                          >
                            <FaTrash />
                          </Button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr>
                    <td colSpan="4" className="text-end fw-bold">
                      Total:
                    </td>
                    <td colSpan="2" className="fw-bold">
                      ${calculateTotal()}
                    </td>
                  </tr>
                </tfoot>
              </Table>
            </div>
          </Card.Body>
        </Card>

        <div className="d-flex justify-content-end gap-2">
          <Button
            variant="outline-secondary"
            onClick={() => navigate('/invoices')}
          >
            Cancel
          </Button>
          <Button variant="primary" type="submit">
            Create Invoice
          </Button>
        </div>
      </Form>
    </div>
  );
}

export default NewInvoice; 